<template>
  <SheetContainer
    title="多音字"
    desc="光标定位到多音字后（或滑选该字），点击设置发音"
  >
    <span class="toggle-btn" slot="title-right" @click="onToggleClick"
      ><i class="size36" :class="[visible ? 'icon-show' : 'icon-hide']"></i
      >{{ visible ? "显示" : "隐藏" }}</span
    >
    <div class="content">
      <ul class="sheet-list">
        <li class="selected-word">
          光标前:<span>「{{ wordText }}」</span>
        </li>
        <li
          v-for="(item, index) in options"
          :key="item.id"
          class="sheet-item"
          :class="{ checked: selectedValue === item.value }"
          @click="onSelect(index)"
        >
          <span>{{ item.name }}</span>
        </li>
        <template v-if="wordText">
          <li
            class="sheet-item custom"
            :class="{ customized }"
            @click="onCustomClick"
          >
            <span>{{ customText }}</span>
          </li>
          <li
            class="sheet-item remove"
            :class="{ removable }"
            @click="onRemoveClick"
          >
            <span>移除</span>
          </li>
        </template>
      </ul>
      <!-- <div class="batch-btn">批量设置多音字</div> -->
    </div>

    <MultiToneInputModal
      :visible.sync="customInputVisible"
      @confirm="onCustomInput"
    />
  </SheetContainer>
</template>
<script>
import SheetContainer from "../sheet-container/sheet-container.vue";
import MultiToneInputModal from "../multi-tone-input-modal/multi-tone-input-modal.vue";
import MultiToneHanlder from "@/views/index/effects/multi-tone";
import { toast } from "@/utils/util";
import { customCollectEvent } from '@/utils/collect';
export default {
  props: {
    value: {
      type: String, // 拼音，删除 ""
      default: "",
    },
    selection: {
      // 当前选中值
      type: Object,
      default: null,
    },
    options: {
      type: Array,
      default: () => [], // 查询到的多音选项
    },
    visible: {
      type: Boolean,
      default: false, // 是否显示编辑器中的多音字
    },
  },
  components: {
    SheetContainer,
    MultiToneInputModal,
  },
  data() {
    return {
      selectedValue: "", //当前选中的值
      customInputVisible: false, // 自定义弹窗是否显示
    };
  },

  computed: {
    wordText() {
      return MultiToneHanlder.getSelectedWord(this.selection);
    },
    removable() {
      return this.selectedValue;
    },
    customized() {
      return (
        this.selectedValue &&
        !this.options.some((option) => option.value === this.selectedValue)
      );
    },
    customText() {
      return this.customized ? this.selectedValue : "+自定义";
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.selectedValue = this.value;
      },
    },
  },
  methods: {
    isValid() {
      const $editor = this.$parent;
      if ($editor.hasEffectRange(this.selection.range, "aliasChange")) {
        toast("别名暂不支持与当前功能组合使用");
        return false;
      }

      // 多发音人特效支持检查
      const speakerNotSupport = $editor.isRangeSpeakerNotSupportEffect(
        this.selection.range,
        "multi-tone"
      );
      if (speakerNotSupport) {
        toast(`${speakerNotSupport.name.split("|")[0]}暂不支持多音字`);
        return false;
      }
      return true;
    },
    //插入/修改
    onSelect(index) {
      if (!this.isValid()) return;
      const selected = this.options[index];
      this.updateValue(selected.value);

      customCollectEvent("editor_duoyinzi", {
        type: "选择",
      });
    },
    // 删除
    onRemoveClick() {
      this.updateValue("");
    },
    // 打开自定义弹窗
    onCustomClick() {
      if (!this.isValid()) return;
      this.customInputVisible = true;
    },
    // 自定义输入
    onCustomInput(value) {
      this.updateValue(value);

      customCollectEvent("editor_duoyinzi", {
        type: "自定义",
      });
    },
    // 更新值
    updateValue(newValue) {
      if (newValue !== this.selectedValue) {
        this.selectedValue = newValue;
        this.$emit("update:value", newValue);
        this.$emit("change", newValue);
      }
    },

    // 显隐拼音
    onToggleClick() {
      const visible = !this.visible;
      this.$emit("visible-change", visible);
      if (visible) {
        customCollectEvent("editor_tools_click", {
          type: "查看拼音",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
i.size36 {
  display: inline-block;
  width: 36px;
  height: 36px;
  background-size: cover;
  vertical-align: -8px;
}
.icon-show {
  background-image: url("~@/assets/images/icon_show@2x.png");
}
.icon-hide {
  background-image: url("~@/assets/images/icon_hide@2x.png");
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  .toggle-btn {
    font-size: 26px;
    font-weight: 400;
    color: #999999;
    i {
      margin-right: 8px;
    }
  }
  .selected-word {
    margin-right: 12px;
    width: 210px;
    font-size: 32px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    span {
      color: #333333;
    }
  }
  .batch-btn {
    margin-bottom: 8px;
    margin-top: auto;
    font-size: 28px;
    font-family: 'HarmonyOS_Sans_SC';
    font-weight: 500;
    color: #3583fb;
    line-height: 40px;
  }
}
</style>